import axios, { Axios, AxiosResponse } from "axios";
import { AppConfig } from "../../config/AppConfig";
axios.defaults.withCredentials = true;

export interface ISignUpCredentials {

    name: string,
    email: string,
    password: string,
}

export interface ISignInCredentials {
    email: string;
    password: string;
}

export interface IRefreshToken {
    token: string;
    refreshToken: string
}
// export interface IToken {
//     token: string
// }
export const signUpApi = async (credentials: ISignUpCredentials): Promise<AxiosResponse> => {
    try {
        const response = await axios.post(`${AppConfig.DEV_SERVER}/sign-up`, credentials);
        // console.log(response)
        return response.data;
    }
    catch (err: any) {
        console.log(err)
        throw err;
    }

}

export const signInApi = async (credentials: ISignInCredentials): Promise<AxiosResponse> => {
    try {
        const response = await axios.post(`${AppConfig.DEV_SERVER}/login`, credentials);
        // console.log(response)
        return response.data;
    }
    catch (err: any) {
        console.log(err)
        throw err;
    }
}

export const resendOtpApi = async (credentials:
    {
        email?: string;
    }
): Promise<AxiosResponse> => {
    const response = await axios.post(`${AppConfig.DEV_SERVER}${AppConfig.API_ENDPOINT}/auth/resend-otp`, credentials);
    return response.data;
}


export const refreshTokenApi = async (token: IRefreshToken): Promise<AxiosResponse> => {
    try {
        const response = await axios.post(`${AppConfig.DEV_SERVER}/refresh-token`, {
            headers: {
                "refresh-token": token,
            }
        });
        // console.log(response)
        return response.data;
    }
    catch (err: any) {
        console.log(err)
        throw err;
    }
}

export const logoutApi = async (): Promise<AxiosResponse> => {
    const response = await axios.post(`${AppConfig.DEV_SERVER}${AppConfig.API_ENDPOINT}/auth/logout`);
    return response.data;
}